export default "__VITE_ASSET__Br4vPHkN__"